import { SxProps, Theme } from '@mui/material';

export const styles: Record<string, SxProps<Theme>> = {
  container: (theme: Theme) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(1),
    padding: theme.spacing(4),
    backgroundColor: theme.palette.common.white,
    borderRadius: '16px',
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(2.5),
      gap: theme.spacing(0.5),
    },
  }),

  fieldsWrapper: (theme: Theme) => ({
    display: 'flex',
    justifyContent: 'space-between',
    gap: theme.spacing(2.5),
    width: '100%',
    mt: theme.spacing(2),
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      gap: theme.spacing(1.5),
      mt: theme.spacing(1),
    },
  }),

  fieldsWrapperItem: (theme: Theme) => ({
    display: 'flex',
    alignItems: 'center',
    flex: '1 1 40%',
    minWidth: '40%',
    maxWidth: `calc(50% - ${theme.spacing(2.5)})`,
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      flex: '2 0 100%',
      minWidth: '100%',
      width: '100%',
    },
  }),

  purposeText: (theme: Theme) => ({
    fontSize: '15px',
    color: theme.palette.text.primary,
    [theme.breakpoints.down('sm')]: {
      fontSize: '13px',
    },
  }),

  checkboxWrapper: (theme: Theme) => ({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    gap: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      gap: theme.spacing(0.75),
    },
  }),

  checkboxLabel: (theme: Theme) => ({
    width: 'fit-content',
    alignItems: 'flex-start',
    [theme.breakpoints.down('sm')]: {
      '& .MuiFormControlLabel-label': {
        fontSize: '14px',
      },
    },
  }),

  radioButtonsFormLabel: (theme: Theme) => ({
    alignItems: 'center',
    fontSize: '15px',
    [theme.breakpoints.down('sm')]: {
      '&.MuiFormLabel-root': {
        fontSize: '14px',
      },
    },
  }),

  radioGroup: (theme: Theme) => ({
    gap: theme.spacing(1.25),
  }),

  radioButtonsLabel: (theme: Theme) => ({
    alignItems: 'center',
    fontSize: '15px',
    [theme.breakpoints.down('sm')]: {
      '& .MuiFormControlLabel-label': {
        fontSize: '14px',
      },
    },
  }),

  radioButton: {
    padding: '5px',
  },

  errorText: (theme: Theme) => ({
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      ml: theme.spacing(3),
      fontSize: '12px',
    },
  }),

  // --- projects ---

  pageContainer: (theme: Theme) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    backgroundColor: '#F5F5F5',
    minHeight: 'calc(100vh - 64px)',
    py: theme.spacing(4),
    px: theme.spacing(2),
  }),

  mainFormPage: {
    height: '100%',
    margin: '0',
    overflow: 'hidden',
  },

  mainFormPageContainer: {
    position: 'relative',
    minHeight: '100vh',
    letterSpacing: '-1px',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#F5F5F5',
  },

  mainFormPageContent: (theme: Theme) => ({
    minHeight: 'calc(100vh - 180px)',
    margin: theme.spacing(3.75, '10%'),
    padding: theme.spacing(4.375),
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'var(--main-bg-color)',
    borderRadius: theme.spacing(1.875),
    [theme.breakpoints.down('sm')]: {
      margin: theme.spacing(0, '10%'),
    },
  }),

  formWrapper: (theme: Theme) => ({
    width: '100%',
    padding: theme.spacing(2.5, 2.5, 0, 2.5),
    maxWidth: '80%',
    mx: 'auto',
  }),

  pageTitle: (theme: Theme) => ({
    fontSize: '1.25rem',
    fontWeight: 500,
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      fontSize: '1rem',
      fontWeight: 400,
    },
  }),

  cardForm: {
    alignItems: 'center',
    backgroundColor: 'var(--main-color-with-opacity-03)',
    padding: '30px 25px',
    borderRadius: '10px',
    border: '1px solid var(--additional-gray)',
    boxShadow: '2px 2px 10px 0 var(--additional-dark-gray-with-opacity-eight)',
  },

  cardFormTitle: (theme: Theme) => ({
    fontSize: '20px',
    padding: '10px 0',
    [theme.breakpoints.down('sm')]: {
      fontSize: '14px',
    },
  }),

  disappearingBlock: (theme: Theme) => ({
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  }),

  contentPanel: {
    height: '100%',
    margin: '0',
    overflow: 'hidden',
  },

  // --- identification ---
};
